// extracted by mini-css-extract-plugin
export default {"Arrow":"ScrollTopArrow_Arrow__H5YWU","Show":"ScrollTopArrow_Show__ZABDm"};